import API from 'libs/axios';
import {
  IQueryGetBulkIncidents,
  IQueryLoadingReportActiveTimeline,
  IQueryLoadingReportActiveUsers,
} from 'pages/reports/interfaces';
import { queryString } from 'utils';

const PATH: string = 'admin/reports';

export const getActiveTimeline = (query: IQueryLoadingReportActiveTimeline) => {
  const params: any = {};

  Object.entries(query).forEach(([key, value]: any) => {
    if (value) params[key] = value;
  });

  const qs: string = queryString(params);

  return API.get(`${PATH}/timeline_users?${qs}`);
};

export const getActiveTimelineTest = (query: IQueryLoadingReportActiveTimeline) => {
  const params: any = {};

  Object.entries(query).forEach(([key, value]: any) => {
    if (value) params[key] = value;
  });

  const qs: string = queryString(params);

  return API.get(`${PATH}/incident_test/timeline_users?${qs}`);
};

export const getActiveUser = (query: IQueryLoadingReportActiveUsers) => {
  const params: any = {};

  Object.entries(query).forEach(([key, value]: any) => {
    if (value) params[key] = value;
  });

  const qs: string = queryString(params);

  return API.get(`${PATH}/active_users?${qs}`);
};

export const getActiveUserIncidentTest = (query: IQueryLoadingReportActiveUsers) => {
  const params: any = {};

  Object.entries(query).forEach(([key, value]: any) => {
    if (value) params[key] = value;
  });

  const qs: string = queryString(params);

  return API.get(`${PATH}/incident_test/active_users?${qs}`);
};

export const postCreateReportBulkIncident = (payload: any) => {
  return API.post(`${PATH}/incident-v2`, payload);
};
export const getReportBulkIncident = (query: IQueryGetBulkIncidents) => {
  const params: any = {};
  Object.entries(query).forEach(([key, value]: any) => {
    if (value) params[key] = value;
  });

  const qs: string = queryString(params);
  return API.get(`${PATH}/incident-v2?${qs}`);
};
